import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import SignUpForm from './index';
import validate from './validate';
import { submit } from '../../actions';

export default compose(
  reduxForm({
    form: 'portalSignUp',
    validate,
  }),
  connect(null, { submit })
)(SignUpForm);
